import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Upload, Icon, notification, Row, Col, Typography, InputNumber, Carousel, Switch } from 'antd';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './SidebarUpdate.css';

const { TextArea } = Input;
const { Paragraph } = Typography;

@inject(
    'CmsLanguageStore',
    'CmsSidebarStore'
)
@observer
class SidebarUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    create = () => {
        this.props.CmsSidebarStore.create().then(() => {
            this.props.CmsSidebarStore.setupdateLoading(false);
            this.props.CmsSidebarStore.setshowModal(false);
            this.props.CmsSidebarStore.getAll();
        });
    }

    update = () => {
        this.props.CmsSidebarStore.update().then(() => {
            this.props.CmsSidebarStore.setupdateLoading(false);
            this.props.CmsSidebarStore.setshowModal(false);
            this.props.CmsSidebarStore.getAll();
        });
    }

    cancel = () => {
        this.props.CmsSidebarStore.setshowModal(false);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsSidebarStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsSidebarStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'Sidebar'
                const titleName = title || 'Default'

                return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsSidebarStore.setImageUrlById(id, response.imageUrl)
                    this.props.CmsSidebarStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            sidebar,
            updateLoading,
            images
        } = this.props.CmsSidebarStore;

        let hasError = true;

        const defaultLang = sidebar.sidebarLanguages.find(fi => fi.languageId === 1);
        if (defaultLang) {
            hasError = images.length === 0 || defaultLang.title === '' || (sidebar.hasDownload && (!sidebar.downloadUrl || sidebar.downloadUrl === '')) || (!sidebar.hasDownload && defaultLang.description === '');
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                sidebar
                                    ?
                                    <>
                                        <Form layout='vertical'>

                                            {/* Title */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Title</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                sidebar.sidebarLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={2}
                                                                                                        value={sidebar.sidebarLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                        onChange={(e) => this.props.CmsSidebarStore.settitle(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                sidebar.sidebarLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <CKEditor
                                                                                                        editor={ClassicEditor}
                                                                                                        data={sidebar.sidebarLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                        onChange={(event, editor) => {
                                                                                                            const data = editor.getData();
                                                                                                            this.props.CmsSidebarStore.setdescription(lang.id, data)
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Sort */}
                                            <>
                                                <Form.Item label='Sort'>
                                                    <InputNumber
                                                        className='stm-width-100'
                                                        value={sidebar.sort}
                                                        onChange={(value) => this.props.CmsSidebarStore.setsort(value)}
                                                        min={1}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Has Download Button */}
                                            <>
                                                <Form.Item label='Has Download Button'>
                                                    <Switch
                                                        checkedChildren='Yes'
                                                        unCheckedChildren='No'
                                                        checked={sidebar.hasDownload}
                                                        onChange={(value) => this.props.CmsSidebarStore.sethasDownload(value)} />
                                                </Form.Item>
                                            </>

                                            {/* Download URL */}
                                            <>
                                                {
                                                    sidebar.hasDownload
                                                        ?
                                                        <>
                                                            <Form.Item label='Download URL'>
                                                                <Input
                                                                    value={sidebar.downloadUrl}
                                                                    onChange={(e) => this.props.CmsSidebarStore.setdownloadUrl(e.target.value)}
                                                                />
                                                            </Form.Item>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    images.map(image => {
                                                        return (
                                                            <Form.Item key={image.id} label={
                                                                image.url === ''
                                                                    ?
                                                                    'Create Banner (Minimum resolution: 640x480)'
                                                                    :
                                                                    <>
                                                                        <Row className='updatesidebar-row-label'>
                                                                            <Col span={12} className='updatesidebar-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                            <Col span={12} className='updatesidebar-col-label-button'>
                                                                                <Button type='danger' onClick={() => this.props.CmsSidebarStore.removeImageById(image.id)}>Delete</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }>
                                                                <Upload
                                                                    listType='picture-card'
                                                                    className='avatar-uploader'
                                                                    showUploadList={false}
                                                                    customRequest={this.dummyRequest}
                                                                    beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                                    onChange={(info) => this.uploadChange(info, image.id, 'Sidebar')}
                                                                >
                                                                    {
                                                                        image.url !== ''
                                                                            ?
                                                                            <img src={image.url} alt='avatar' className='updatesidebar-img' />
                                                                            :
                                                                            <div>
                                                                                <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                <div className='ant-upload-text'>Upload</div>
                                                                            </div>}
                                                                </Upload>
                                                            </Form.Item>
                                                        )
                                                    })
                                                }
                                            </>

                                            {/* Preview */}
                                            <>
                                                <Form.Item label='Preview Banner'>
                                                    <Row>
                                                        <Col span={24} className='updatesidebar-col-preview-container'>
                                                            {
                                                                images.length === 1
                                                                    ?
                                                                    null
                                                                    :
                                                                    <Row>
                                                                        <Col className='updatesidebar-col-preview-img'>
                                                                            <Row>
                                                                                <Col
                                                                                    span={24}
                                                                                    className={images.length === 2 ? 'updatesidebar-col-carousel-container-single' : 'updatesidebar-col-carousel-container'}
                                                                                >
                                                                                    <Carousel>
                                                                                        {
                                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                                return (
                                                                                                    <div key={image.id} className='updatesidebar-div-carousel'>
                                                                                                        <Row className='updatesidebar-row-carousel'>
                                                                                                            <Col span={24} className='updatesidebar-col-carousel'>
                                                                                                                <img className='updatesidebar-img-carousel' src={image.url} alt={image.id} />
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Carousel>
                                                                                </Col>
                                                                            </Row>
                                                                            <>
                                                                                {
                                                                                    sidebar.sidebarLanguages.find(fi => fi.languageId === 1)
                                                                                        ?
                                                                                        <>
                                                                                            <Row className='updatesidebar-row-detail'>
                                                                                                <Paragraph className='clr-theme-dark-1'>
                                                                                                    <Markup content={sidebar.sidebarLanguages.find(fi => fi.languageId === 1).description} />
                                                                                                </Paragraph>
                                                                                            </Row>
                                                                                        </>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </>

                                                                        </Col>
                                                                    </Row>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </>

                                            {/* Button */}
                                            <>
                                                <Form.Item>
                                                    {
                                                        sidebar.id === 0
                                                            ?
                                                            <Button onClick={this.create} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                            :
                                                            <Button onClick={this.update} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>
                                                    }

                                                    <Button onClick={this.cancel}>Cancel</Button>
                                                </Form.Item>
                                            </>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default SidebarUpdate;